import { useCallback, useRef } from 'react'
import * as React from 'react'

import { Box, Grid } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'

import ProductGridCard from '~/components/cards/ProductCard/ProductGridCard'
import SectionCard from '~/components/cards/SectionCard'
import {
  headerHeight,
  mobileHeaderHeight
} from '~/components/layouts/Header/Header.style'
import LoaderBox from '~/components/shared/LoaderBox'

import Paths from '~/utils/paths'

export const DealerItemsSection = ({
  listings,
  loading,
  data,
  pagy,
  isMobile,
  isValidating,
  router
}) => {
  const ref = useRef(null)
  const handleChangePage = useCallback(
    (newPage) => {
      const item = ref.current?.getBoundingClientRect()

      const scrollYTo =
        item?.top +
        window.pageYOffset -
        (isMobile ? mobileHeaderHeight : headerHeight)
      window.scrollTo({ top: scrollYTo, behavior: 'smooth' })

      router.push({
        query: { ...router.query, page: newPage }
      })
    },
    [isMobile]
  )
  const placeholderListings = new Array(12).fill({})
  return (
    <SectionCard
      title="Items from this seller"
      displayLink={!!listings.length}
      linkHref={Paths.search.buildSearch({
        by_dealer: data.name
      })}
      titleSize={20}
      ref={ref}
    >
      <Box px={2.5} pb={2.5}>
        {!loading && !listings.length ? (
          <LoaderBox loading={loading} length={listings.length} />
        ) : (
          <Grid container spacing={2}>
            {(loading ? placeholderListings : listings).map(
              (listing, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={loading ? index : listing.id}
                >
                  <ProductGridCard data={listing} loading={isValidating} />
                </Grid>
              )
            )}
          </Grid>
        )}
        {pagy?.pages > 1 && (
          <Box mx="auto" display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={pagy?.pages}
              color="primary"
              shape="rounded"
              size={isMobile ? 'small' : 'large'}
              onChange={(_e, newPage) => handleChangePage(newPage)}
              page={+router.query.page || 1}
            />
          </Box>
        )}
      </Box>
    </SectionCard>
  )
}
